import {CustomerStateType} from "./CustomerStateType";
import {CustomercfgView} from "../subaccount/CustomercfgView";
import {Format} from "../media/MediaTypes";
import Sort from "../../util/pattern/Sort";
import {SortDirection} from "../common/SortDirection";
import {random} from "../util/math/Random";
import {ResourceMetricData} from "../resourcemetric/ResourceMetricTypes";

interface CustomerInfoDataJson {
    customer: CustomerAllData;
    subcustomers: CustomerAllData[];
    liveBackends: IBackendLiveData[];
    usageTotals: CustomerUsageTotals[];
}

interface CustomerInfoData {
    customer: CustomerAllData;
    subcustomers: CustomercfgView[];
    liveBackends: IBackendLiveData[];
    usageTotals: CustomerUsageTotals[];
}

interface CustomerAllData {
    cfg: CustomercfgData;
    resourceMetrics: ResourceMetricData[];
}

export interface CustomerUsageTotals {
    cId: number;
    appCfgs: number;
}

interface CustomercfgData {
    cId: number;
    repoBackendId: number;
    repoStreamBackendId: number;
    defaultLiveBackendId: number | null;
    parentCId: number | null;
    customerStateType: CustomerStateType;
    label: string;
    playerEnableContentLock: boolean;
    playerRequireSignature: boolean;
    created: number;
    updated: number;
    quota: CustomercfgQuotaView;
    reseller: CustomercfgResellerData;
}

interface CustomercfgQuotaData {
    allowAds: boolean;
    allowDvr: boolean;
    allowEncryptLive: boolean;
    allowFeed: boolean;
    allowHlsLink: boolean;
    allowStream: boolean;
    allowUploadProfile: boolean;
    allowVideo: boolean;
    allowOverage: boolean;
    intervalStart: number;
    intervalType: string;
    simulatedLiveLimit: number | null;
    storageBytesLimit: number | null;
    storageBytesUsed: number;
    subaccountLimit: number | null;
    transferBytesLimit: number | null;
    transferBytesUsed: number;
    videoLimit: number | null;
    videostreamLimit: number | null;
}

interface CustomercfgQuotaView {
    features: CustomercfgQuotaFeatures;
    limits: CustomercfgQuotaViewLimits;
}

enum IntervalTypeId {
    Month = 1,
    Quarter = 2,
    SemiAnnual = 3,
    Annual = 4
}

interface CustomercfgQuotaFeatures {
    account: CustomercfgQuotaFeaturesAccount;
    app: CustomercfgQuotaFeaturesApp;
}

interface CustomercfgQuotaFeaturesAccount {
    allowAds: boolean;
    allowDvr: boolean;
    allowEncryptLive: boolean;
    allowEncryptVod: boolean;
    allowFeed: boolean;
    allowHlsLink: boolean;
    allowOverage: boolean;
    allowStream: boolean;
    allowUploadProfile: boolean;
    allowVideo: boolean;
}

export interface CustomercfgQuotaFeaturesApp {
    appCfgLimit: number | null;
    allowAppletv: boolean;
    allowFiretv: boolean;
    allowRoku: boolean;
    allowWeb: boolean;
    allowAndroidtv: boolean;
    allowAndroid: boolean;
    allowIos: boolean;
}

interface CustomercfgQuotaViewLimits {
    intervalStart: number; // Unix Epoch timestamp
    intervalType: string;
    simulatedLiveLimit: number | null;
    storageBytesLimit: number | null;
    storageBytesUsed: number;
    storagePurgeCutoffDays: number | null;
    subaccountLimit: number | null;
    transferBytesLimit: number | null;
    transferBytesUsed: number;
    videoLimit: number | null;
    videostreamLimit: number | null;
}

interface CustomercfgResellerData{
    domain: string | null;
    logoFileId: number | null;
    logoFormat: string | null;
    supportUri: string | null;
    supportPhone: string | null;
}


enum QuotaIntervalType {
    Month = "month",
    Quarter = "quarter",
    SemiAnnual = "semi_annual",
    Annual = "annual"
}

interface IBackendLiveData {
    backendId: number;
    backendTypeId: number;
    allowProvisioning: boolean;
    dvr: boolean;
    dvrArchiveStrategyType: DvrArchiveStrategyType;
    encryptHlsAes: boolean;
    locationLabel: string;
    rtmpServerUrl: string;
}

class BackendUtil{
    static getUSABackends(liveBackends: IBackendLiveData[]): IBackendLiveData[] {
        return liveBackends
            .filter(b => b.locationLabel.toLowerCase().startsWith("us"))
            .sort(Sort.getSortFn((b: IBackendLiveData) => b.locationLabel, SortDirection.Asc));
    }

    static getNonUSABackends(liveBackends: IBackendLiveData[]): IBackendLiveData[] {
        return liveBackends
            .filter(b => !b.locationLabel.toLowerCase().startsWith("us"))
            .sort(Sort.getSortFn((b: IBackendLiveData) => b.locationLabel, SortDirection.Asc));
    }
}

enum DvrArchiveStrategyType {
    Append = "append",
    Delete = "delete"
}


enum BackendTypeId {
    Repo1 = 1,
    LiveOrigin1 = 2
}

export {CustomerAllData, CustomerInfoDataJson, CustomerInfoData, CustomercfgData, CustomercfgQuotaView, DvrArchiveStrategyType, BackendUtil, IBackendLiveData, QuotaIntervalType}